<template>
  <a-modal width="466px" class="modify-phone" :visible="show" :footer="null" @cancel="$emit('update:show', false)">
    <template v-slot:title>
      <div class="modal-title">
        修改手机号
      </div>
    </template>
    <div class="phone-box" v-if="stage === 1">
      <a-form-model ref="oldForm" :rules="rules" :model="oldPhone">
        <a-form-model-item style="margin-bottom: 0px;">
          <p class="title">当前手机号</p>
        </a-form-model-item>
        <a-form-model-item prop="phone">
          <a-input :maxLength="11" v-model="oldPhone.phone" :disabled="true"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="verifyCode">
          <div class="verify-code">
            <a-input :maxLength="6" v-model="oldPhone.verifyCode"></a-input>
            <div class="verify-btn" @click="sendVerifyCode(oldPhone, 'oldForm')">
              {{ oldPhone.time === 60 ? '发送验证码' : oldPhone.time }}
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="form-btn" size="large" type="primary" @click="goNext(2)">下一步</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="phone-box" v-if="stage === 2">
      <a-form-model ref="newForm" :rules="rules" :model="newPhone">
        <a-form-model-item style="margin-bottom: 0px;">
          <p class="title">输入你需要绑定的手机号</p>
        </a-form-model-item>
        <a-form-model-item prop="phone">
          <a-input :maxLength="11" v-model="newPhone.phone"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="verifyCode">
          <div class="verify-code">
            <a-input :maxLength="6" v-model="newPhone.verifyCode"></a-input>
            <div class="verify-btn" @click="sendVerifyCode(newPhone, 'newForm')">
              {{ newPhone.time === 60 ? '发送验证码' : newPhone.time }}
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="form-btn" size="large" type="primary" @click="submit">确定</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { sendOldPhoneNumber, sendNewPhoneNumber, verifyOldPhoneNumber, verifyNewPhoneNumber, getStuInfo } from '@/api/user'
import { mapState } from 'vuex'

export default {
  props: {
    // 展示
    show: {
      type: Boolean,
      require: true,
      default: false
    },
    // 旧手机号
    phone: {
      type: [String, Number],
      require: true,
      default: ''
    }
  },
  data() {
    return {
      stage: 1,
      defaultPhone: {
        phone: '',
        verifyCode: '',
        timer: null,
        time: 60
      },
      oldPhone: {
        phone: '',
        verifyCode: '',
        timer: null,
        time: 60
      },
      newPhone: {
        phone: '',
        verifyCode: '',
        timer: null,
        time: 60
      },
      rules: {
        phone: [
          { required: true, trigger: 'none', message: '请输入手机号码' },
          { required: true, pattern: /^1[3456789]\d{9}$/, trigger: 'none', message: '手机号码格式不正确' }
        ],
        verifyCode: [{ required: true, message: '请输入验证码' }]
      }
    }
  },
  computed: {
    ...mapState({
      info: state => state.system.orgInfo
    })
  },
  watch: {
    show: {
      handler(val) {
        if (!val) {
          // 关闭弹窗 清空所有定时器并重置表单数据
          this.clInterval(this.oldPhone)
          this.clInterval(this.newPhone)
          this.stage = 1
          this.resetData()
        } else {
          this.oldPhone.phone = this.phone
        }
      },
      immediate: true
    }
  },
  methods: {
    // 设置定时器
    interval(source) {
      source.timer = setInterval(() => {
        if (source.time-- <= 0) {
          source.time = 60
          this.clInterval(source)
        }
      }, 1000)
    },
    // 清空定时器
    clInterval(source) {
      clearInterval(source.timer)
      source.timer = null
      source.time = 60
    },
    // 发送验证码
    sendVerifyCode(source, form) {
      this.$refs[form].validateField('phone', async res => {
        if (!res) {
          if (source.timer) return
          switch (form) {
            case 'oldForm':
              await sendOldPhoneNumber()
              break
            case 'newForm':
              {
                const data = {
                  ocode: this.info.ocode,
                  phoneNumber: this.newPhone.phone,
                  resetToken: this.oldPhone.resetToken
                }
                await sendNewPhoneNumber(data)
              }
              break
            default:
              break
          }
          this.interval(source)
        }
      })
    },
    // 下一步
    goNext(stage) {
      this.$refs.oldForm.validate(async res => {
        if (res) {
          const res = await verifyOldPhoneNumber({ smsCode: this.oldPhone.verifyCode })
          this.oldPhone.resetToken = res.resetToken
          this.stage = stage
          this.clInterval(this.oldPhone)
        }
      })
    },
    // 确定提交
    submit() {
      this.$refs.newForm.validate(async res => {
        if (res) {
          const { phone, verifyCode } = this.newPhone
          const data = {
            ocode: this.info.ocode,
            phoneNumber: phone,
            smsCode: verifyCode
          }
          const res = await verifyNewPhoneNumber(data)
          const { accessToken: token } = res.token
          this.$store.commit('SET_TOKEN', token)
          const resInfo = await getStuInfo()
          this.$store.commit('SET_USER_INFO', resInfo)
          this.$store.commit('SET_AUDITION', res.isAudition || '')
          this.$emit('success', phone)
          this.$emit('update:show', false)
        }
      })
    },
    // 重置数据
    resetData() {
      this.newPhone = JSON.parse(JSON.stringify(this.defaultPhone))
      this.oldPhone = JSON.parse(JSON.stringify(this.defaultPhone))
    }
  }
}
</script>

<style scoped lang="less">
.modify-phone {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  .modal-title {
    text-align: center;
    font-weight: 600;
    font-size: 16px;
  }
  .phone-box {
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
      font-weight: 600;
    }
    .form-btn {
      width: 100%;
      background: #4b7dfd;
      border-radius: 5px;
    }
    .verify-code {
      display: flex;
      align-items: center;
      input {
        width: 272px !important;
        margin-right: 10px;
      }
      .verify-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f7fa;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #4b7dfd;
        flex: 1;
        height: 48px;
        cursor: pointer;
      }
    }
  }

  .ant-form-item {
    display: flex;
    width: 100%;
    margin-bottom: 19px;
    &.ant-form-item-with-help {
      margin-bottom: 0;
    }
    .input-box {
      display: flex;
      align-items: center;
    }
    .iconStyle {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 10px;
      top: 0px;
    }
    /deep/ .ant-form-item-label {
      line-height: 48px;
    }
    // align-items: center;
    /deep/ .ant-form-item-control-wrapper {
      width: 100%;
      .ant-form-item-control {
        height: 100%;
        .ant-form-explain {
          font-size: 12px;
          line-height: 22px;
        }
      }
      input {
        box-sizing: border-box;
        width: 100%;
        height: 48px;
        background: #f5f8fa;
        border-radius: 6px;
        padding-right: 30px;
      }
    }
  }
}
</style>
